import React from 'react';
import './SkipLink.css';

/**
 * Skip to main content link – rodomas tik gavus fokusą (klaviatūra).
 * Atitinka WCAG 2.1 (2.4.1 Bypass Blocks).
 */
function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      Pereiti prie pagrindinio turinio
    </a>
  );
}

export default SkipLink;
